import { getAxiosConfig, getAxiosInstance } from "@ps/api-utils";
import { Store } from "redux";
import { DefaultApi } from "./openapi-client";

class APIService {
  public API: DefaultApi;

  private token?: string;

  private store?: Store;

  constructor() {
    const baseConfig = getAxiosConfig();
    this.API = new DefaultApi(baseConfig);
  }

  public setConfig(token: string) {
    this.token = token;
    this.setApi();
  }

  public setStore(store: Store) {
    this.store = store;
    this.setApi();
  }

  private setApi() {
    let axiosInstance;
    const baseConfig = getAxiosConfig();
    if (this.store) {
      axiosInstance = getAxiosInstance(this.store);
    }

    this.API = new DefaultApi(
      {
        ...baseConfig,
        accessToken: this.token,
      },
      undefined,
      axiosInstance,
    );
  }
}

export default new APIService();
